import React, { useEffect, useState } from "react"

import {
    Row,
    Col,
    Card,
    CardBody,
    FormGroup,
    Label,
    Input,
    Container,
    FormFeedback,
    Form,
} from "reactstrap"
// Formik validation
import { useFormik } from "formik"

//Import Breadcrumb
import Breadcrumbs from "../../../../components/Common/Breadcrumb"
import { useHistory, useParams } from "react-router-dom"
import ResultHandler from "../../../../components/ResultHandler"
import { editCollection, getCollection } from "../../../../api/collections"
import FormButtonHandler from "../../../../components/FormButtonHandler"
import { useResponse } from "../../../../hooks/useResponse"
import { useTranslation } from "react-i18next"
import { useGetInstence } from "../../../../hooks/useGetInstence"

import FIELDS from "./CONSTANT"
import CollectionForm from "./CollectionForm"
import * as Yup from "yup"
import moment from "moment"
import AddNegativeHours from "./AddNegativeHours"


const TYPES = {
    'select': null,
    'add-more': [],
    'checkbox': false
}

const initialValues = {}
const FIELDS_VALIDATION = {}

FIELDS.forEach(f => {
    initialValues[f.key] = TYPES[f.type] ? TYPES[f.type] : "" 
    if(f.type == 'file'){
        FIELDS_VALIDATION[f.key+"_preview"] = Yup.string().required("This Field Is Required")

    }else{
        FIELDS_VALIDATION[f.key] = Yup.string().required("This Field Is Required")
    }
})


const EditCollection = () => {
    let navigate = useHistory()

    const { t } = useTranslation()

    const params = useParams()

    const [editedCollection, setEditedCollection] = useState(null)
    const [shift, setShift] = useState(null)
    const [employees, setEmployees] = useState([])
    const [employeesLoaded, setEmployeesLoaded] = useState(false)

    const { instenceLoading, instenceError, instenceSuccess } = useGetInstence(
        getCollection,
        params.id,
        response => {
            setShift(response.data.data.hoursCollection.shift)
            setEditedCollection({
                ...response.data.data.hoursCollection, 
                hours: response.data.data.hoursCollection.hours.map(h => ({...h, disabled: h.payslipes.length > 0}))})
        }
    )

    useEffect(() => {
        if(editedCollection && employees.length > 0 && employees.find(em => em.default)){
            setEmployees(ems => {
                return ems.map(em => {
                    const periods = editedCollection?.hours?.find(h => h.employee_id == em.employee_id)?.periods || []
                    const newPeriods = Array.from({ length: periods.length }, () => ({from: null, to: null, length: null, breakHours: 0}));
                    periods.forEach((period, idx) => {
                        if(period.from){
                            let periodIdx = Math.floor((new Date(period.from) - new Date(editedCollection.date_from)) / (1000 * 60 * 60 * 24))
                            const from = moment(new Date(period.from)).format("HH:mm")
                            const to = moment(new Date(period.to)).format("HH:mm")
                            newPeriods[periodIdx] = {...period, from, to}
                        }
                    });

                    return {
                        ...em, 
                        id: editedCollection?.hours?.find(h => h.employee_id == em.employee_id)?.id,
                        default: false, 
                        disabled: editedCollection?.hours?.find(h => h.employee_id == em.employee_id)?.disabled,
                        hoursLength: editedCollection?.hours?.find(h => h.employee_id == em.employee_id)?.hoursLength,
                        periods: newPeriods
                    }
                })
            })
            setEmployeesLoaded(true)
        }
    }, [editedCollection, employees])

    const { setData, loading, error, success } = useResponse(editCollection, () => {
        navigate.goBack()
    })

    const [finalData, setFinalData] = useState(null)

    // Form validation
    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,
        initialValues: {
            ...editedCollection
        },
        validationSchema: Yup.object(FIELDS_VALIDATION),
        onSubmit: values => {
          if(!employees.find(e => e.error)){   
              const data = getData(values)
              setData({ type: "edit", id: params.id, data })
          }
      },
    })

    useEffect(() => {
      if(!employees.find(e => e.error)){   
        const values = validation.values
        const data = getData(values)
        setFinalData(data)
      }
    } , [validation.values, employees, shift, editedCollection])

    const getData = (values) => {      
      function getDate(numOfDays){
        const date = values.date_from
        return moment(date).add(numOfDays, 'd').format("YYYY-MM-DD")
      }

      let data = {
        ...values,
        shift_id: shift?.id,
        hours: employees
        .filter(e => !e.disabled)
        .map(e => ({
          ...e, 
          hourPrice : shift?.price,
          periods: e.periods
            .map((p, i) => ({
                ...p, 
                from: new Date(getDate(i)+"T"+p.from+":00").toUTCString(), 
                to: new Date(getDate(i)+"T"+p.to+":00").toUTCString()
            }))
            .map(p => p.length > 0 ? p : {})       
        })), 
      }

      return data
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid={true}>
                    <Breadcrumbs
                        title={t("Collections")}
                        breadcrumbItem={"Edit Collection"}
                    />
                    
                        {editedCollection && (
                            <Form
                                className="needs-validation"
                                onSubmit={e => {
                                    e.preventDefault()
                                    validation.handleSubmit()
                                    return false
                                }}
                            >
                                <CollectionForm 
                                    shift={shift}
                                    setShift={setShift}
                                    employees={employees} 
                                    setEmployees={setEmployees} 
                                    poolId={editedCollection.pool_id} 
                                    validation={validation} 
                                    isEmployessLoaded={employeesLoaded}
                                    negativeHours={<AddNegativeHours finalData={finalData} />}
                                />

                                <FormButtonHandler btnTxt="Edit" loading={loading} />
                            </Form>
                        )}

                        <ResultHandler
                            loading={instenceLoading}
                            error={error}
                            success={success}
                            successMsg={"Updated Successfully!"}
                        />
                                
                </Container>
            </div>
        </React.Fragment>
    )
}

export default EditCollection